import TopicForm from 'app/shared-components/channel/TopicForm';
import UserView from 'app/shared-components/user/UserView';
import { useParams } from 'react-router-dom';
import { selectCommentPanelPostId, setCommentPanelPostId } from "./store/channelAppSlice";
import { useSelector, useDispatch} from 'react-redux';
import {createElement, useContext} from 'react';
import { useLocation } from 'react-router-dom';
import FileItemDetail from "app/shared-components/file/FileItemDetail";
import CommentPanel from "app/shared-components/chat/CommentPanel";
import RightSidebarContainer from 'app/shared-components/layout/RightSidebarContainer';
import useLocationStatus from './useLocationStatus';
import {ChannelAppContext} from "app/shared-components/channel/channelApp/ChannelApp";

function ChannelRightSidebarContent({type, element, sidebarElementFullHeight}) {
  const routeParams = useParams();
  const location = useLocation();
  const dispatch= useDispatch();
  const { groupId, memberId, userId, channelId, fileId, clientId, callId } = routeParams;
  const {isTopic, isFile, isMember, isVideoCall} = useLocationStatus();
  const { setRightSidebarOpen } = useContext(ChannelAppContext);
  const currentLocation= location.pathname;
  const commentPanelPostId= useSelector(selectCommentPanelPostId());
  const isCommentPanel = Boolean(commentPanelPostId);
  const appBaseUrl= "/apps/" + type + "/" + groupId;
  const useCloseClink = isMember || isCommentPanel;
  const returnPath= isCommentPanel ? currentLocation : -1;
  if (!element && !isTopic && !isMember && !isCommentPanel && !isFile) return null;

  function onClose(){
     console.log("onClose: " + currentLocation);
     if (isCommentPanel) {
       dispatch(setCommentPanelPostId(null));
       setRightSidebarOpen(false);
     }
  }
  
  return (
	 <RightSidebarContainer closeLink={useCloseClink ? returnPath : undefined} onClose={onClose} fullHeight={sidebarElementFullHeight || isCommentPanel} >
	    { element && createElement(element)}
      { isTopic && <TopicForm type={type}/> }
      { isMember && <UserView userId={memberId} returnPath={returnPath} /> }
      { isFile && <FileItemDetail itemId={fileId} returnPath={returnPath} /> }
      { (isCommentPanel && !isTopic && !isMember && !isFile) && <CommentPanel postId={commentPanelPostId} hidePost={isVideoCall}  /> }
   	</RightSidebarContainer>  
  );
}

export default ChannelRightSidebarContent;
